import Feature28_morph from './Feature28_morph'
export default Feature28_morph
